import React, { useState } from "react";
import type { WizardData } from "./index";
import { buildDevWizardFill, isDevWizardHelpersEnabled } from "./listingWizardDevFill";

interface DevWizardToolbarProps {
  currentStep: number;
  onFill: (data: WizardData, step: number) => void;
  onReset: () => void;
  darkMode: boolean;
}

const STEP_OPTIONS = [
  { step: 1, label: "VIN" },
  { step: 2, label: "Details" },
  { step: 3, label: "Photos" },
  { step: 4, label: "Pricing" },
  { step: 5, label: "Review" },
];

const DevWizardToolbar: React.FC<DevWizardToolbarProps> = ({
  currentStep,
  onFill,
  onReset,
  darkMode,
}) => {
  const [loading, setLoading] = useState(false);

  if (!isDevWizardHelpersEnabled()) {
    return null;
  }

  const handleFill = async (step: number) => {
    setLoading(true);
    try {
      const data = await buildDevWizardFill();
      onFill(data, step);
    } catch (err) {
      console.error("[dev-wizard] fill failed:", err);
      alert("Dev fill failed — see console.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="dev-wizard-toolbar"
      style={{
        position: "fixed",
        bottom: 16,
        right: 16,
        zIndex: 9999,
        background: darkMode ? "#1e1e1e" : "#fff",
        border: `1px solid ${darkMode ? "#444" : "#ccc"}`,
        borderRadius: 10,
        padding: "10px 12px",
        boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
        fontSize: 12,
        maxWidth: 280,
      }}
    >
      <div
        style={{
          fontWeight: 600,
          marginBottom: 8,
          color: darkMode ? "#ffb74d" : "#e65100",
        }}
      >
        Dev: listing wizard
      </div>
      <div style={{ color: darkMode ? "#aaa" : "#666", marginBottom: 8, lineHeight: 1.4 }}>
        Step {currentStep}/5 · fills test VIN, 3 placeholder photos, Boston location
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 8 }}>
        {STEP_OPTIONS.map(({ step, label }) => (
          <button
            key={step}
            type="button"
            disabled={loading}
            onClick={() => handleFill(step)}
            style={{
              padding: "4px 8px",
              fontSize: 11,
              borderRadius: 4,
              border: "1px solid #1976d2",
              background: step === 5 ? "#1976d2" : "transparent",
              color: step === 5 ? "#fff" : "#1976d2",
              cursor: loading ? "wait" : "pointer",
            }}
          >
            {loading ? "…" : `→ ${label}`}
          </button>
        ))}
      </div>
      <button
        type="button"
        disabled={loading}
        onClick={onReset}
        style={{
          padding: "4px 8px",
          fontSize: 11,
          borderRadius: 4,
          border: `1px solid ${darkMode ? "#666" : "#999"}`,
          background: "transparent",
          color: darkMode ? "#ccc" : "#666",
          cursor: "pointer",
        }}
      >
        Reset form
      </button>
      <div style={{ marginTop: 8, color: darkMode ? "#777" : "#999", fontSize: 10, lineHeight: 1.35 }}>
        Bookmark:{" "}
        <code style={{ fontSize: 10 }}>?devFill=1&amp;step=5</code> on{" "}
        <code style={{ fontSize: 10 }}>/newlisting</code>
      </div>
    </div>
  );
};

export default DevWizardToolbar;
